module.exports = __webpack_public_path__ + "img/resources-1920.5d726314.jpg";